<template>
	<div class="home">
		<div class="banner_box">
			<el-carousel height="500px" ref="cardShow" arrow="never" :interval="3000" @change="changeFun">
				<el-carousel-item v-for="(item, index) in trainingNotice1" :key="index">
					<img
						style="width: 100%; height: 100%; object-fit: cover"
						:src="item.banner_text"
						alt=""
					/>
					<div class="arrow_box">
						<div class="mainTitle">{{ item.title }}</div>
						<div class="subtitle" v-if="item.countdown > 0"> 开课倒计时：{{ item.showTime }} </div>
						<div class="subtitle" v-else>已结束</div>
						<div class="btn hover-a" @click="goCoursedDetails(item)">
							查看详情
							<img
								style="margin-bottom: 2px; margin-left: 4px"
								src="../image/jiantou1.png"
								alt=""
							/>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>

		<!--  -->
		<div class="serve_box">
			<div class="title">
				<div class="dividing-line"></div>
				<div class="top headline">
					{{ shareText[0] ? shareText[0].name : '往期课程回顾' }}
				</div>
				<div class="bottom small_caption">
					{{ shareText[0] ? shareText[0].vice_name : '温故知新，把复杂的知识简单化' }}
				</div>
				<div style="top: 50px; left: 0" class="serve_box-bj">
					<img src="../image/index/qiu1.png" alt="" />
				</div>
			</div>
		</div>
		<!--  -->

		<div class="content-box wow animate__animated animate__fadeInUp">
			<div class="class-box">
				<div class="class-box-nav">
					<div class="nav-left">
						<!-- <div class="title">类型</div> -->
						<div class="item">
							<!-- <div
                class="nav"
                :class="{ tap: activeType == item.id }"
                v-for="(item, index) in typeList"
                :key="index"
                @click="onBindSelectType(item.id)"
              >
                {{ item.name }}
              </div> -->
							<el-tabs v-model="activeName" @tab-click="handleClick">
								<el-tab-pane
									v-for="(item, index) in typeList"
									:key="index"
									:label="item.name"
									:name="item.id + ''"
								>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
					<div class="nav-right">
						<el-input
							placeholder="请输入课程名称/授课老师"
							suffix-icon="el-icon-search"
							v-model="input2"
							@input="inputSearchCourseList"
						>
						</el-input>
					</div>
				</div>
				<div class="class-box-item">
					<div class="material-share-list">
						<div
							class="material-share-item"
							v-for="(item, index) in classList"
							:key="index"
							@mouseover="mouseoverMaterialShare(index)"
							@mouseout="mouseoutMaterialShare"
							@click="goCoursedDetails(item)"
						>
							<div class="material-share-img">
								<img
									class="share-img transition_effect"
									:class="{
										hover: index === materialShareIndex,
									}"
									:src="item.banner_text"
								/>
								<div class="material-share-popup">
									<div class="title">{{ classType[item.course_type] }}</div>
									<!-- <div @click="gocase_details" class="btn-download">
                    查看详情
                    <img
                      class="btn-download-img"
                      src="../assets/imgs/jiantoubai@2x.png"
                      alt=""
                    />
                  </div> -->
								</div>
							</div>
							<div class="material-share-title">
								<span v-show="item.is_recommend == 1 && input2">推荐</span>
								{{ item.title }}
							</div>
							<div class="material-share-label" style="cursor: pointer">
								查看详情
								<!-- <img
                  style="margin-bottom: 2px; margin-left: 4px"
                  src="../image/jiantou1.png"
                  alt=""
                /> -->
								<div class="label_img"></div>
							</div>
						</div>
						<div class="none-list" v-if="classList.length <= 0">
							<!-- <img class="none-list-img" src="../assets/icon/classsearchnone.png" /> -->
							<img class="none-list-img" src="../assets/imgs/search_null.png" />
							<div>暂无相关内容</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bj">
				<img src="../image/qiu3.png" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { $trainingNotice, $courseList, $indexTitle } from '@/api/index';

	export default {
		name: 'Home',
		data() {
			return {
				shareText: '',
				classType: ['', '线上', '线下'],
				debounceTimer: null,
				timer: null,
				centerDialogVisible: false,
				bannerIndex: 0,
				card_index: 0,
				materialShareIndex: '',

				input2: '',
				trainingNotice1: [],

				// 类型选择
				typeList: [],
				// 选中类型
				activeType: '0',
				// 课程列表
				classList: [],

				powerSate: false,

				activeName: '0',
			};
		},
		computed: {
			//计算属性
		},
		components: {},
		destroyed() {
			clearInterval(this.timer);
		},
		mounted() {
			let { courseType } = this.$route.query;
			this.activeType = courseType || '0';
			this.trainingNotice();
			this.courseList();
			this.getUserInfo();
			this.$nextTick(() => {
				setTimeout(() => {
					this.activeName = this.activeType;
				}, 1500);
			});
			new this.$wow.WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 0,
				mobile: true,
				live: true,
			}).init();
		},
		methods: {
			//获取往期回顾文字
			getindexText() {
				$indexTitle({
					ids: 19,
				}).then((res) => {
					// console.log(res);
					this.shareText = res.data;
				});
			},
			handleClick(tab, event) {
				this.onBindSelectType(tab.name);

				let scrollHeight = window.scrollY;
				this.$router.push({ query: { courseType: tab.name } });
				window.scrollTo(0, scrollHeight);
			},

			getUserInfo() {
				if (!(JSON.stringify(this.$store.state.userInfo) == '{}')) {
					if (this.$store.state.userInfo.token) {
						this.powerSate = true;
					}
				}
			},
			inputSearchCourseList(val) {
				if (this.debounceTimer) {
					clearTimeout(this.debounceTimer);
				}
				this.debounceTimer = setTimeout(() => {
					clearTimeout(this.debounceTimer);
					this.debounceTimer = null;
					this.courseList();
				}, 600);
				// console.log(val);
			},
			onBindSelectType(val) {
				this.activeType = val;
				this.courseList();
			},
			trainingNotice() {
				$trainingNotice()
					.then((response) => {
						this.trainingNotice1 = response.data;
						this.showTimeLeft();
					})
					.catch((res) => {
						console.log(res);
					});
			},
			courseList() {
				$courseList({
					content: this.input2,
					type: this.activeType,
				})
					.then((response) => {
						if (response) {
							this.typeList = response.data.type_name.map((item) => {
								item.id = String(item.id);
								return item;
							});
							this.typeList.unshift({ id: '0', name: '全部' });
							this.classList = response.data.type_data;
						}
					})
					.catch((res) => {
						console.log(res);
					});
			},
			goCoursedDetails(val) {
				// if (this.powerSate) {
				this.$router.push({
					path: '/coursed_details',
					query: { id: val.id, courseType: this.activeName },
				});
				// } else {
				// this.$router.push("login");
				// }
			},
			mouseoverMaterialShare(el) {
				this.materialShareIndex = el;
			},
			mouseoutMaterialShare() {
				this.materialShareIndex = '';
			},
			show_card(e) {
				this.card_index = e;
			},
			hidden_card() {
				this.card_index = 0;
			},
			changeFun(e) {
				this.bannerIndex = e;
				this.text = this.trainingNotice1[e];
			},
			arrowClick(val) {
				if (val === 'right') {
					this.$refs.cardShow.next();
				} else {
					this.$refs.cardShow.prev();
				}
			},
			showTimeLeft() {
				let nowDateTime = new Date();

				this.trainingNotice1.forEach((key) => {
					// 防止延迟
					key.showTime = this.timeOld(nowDateTime, key.countdown);
				});

				this.timer = setInterval(() => {
					this.trainingNotice1.forEach((key) => {
						key.showTime = this.timeOld(nowDateTime, key.countdown);
					});
					this.$forceUpdate();
				}, 1000);
			},
			timeOld(nowTime, time) {
				if (time) {
					var nowtime = new Date(), //获取当前时间
						endtime = nowTime.getTime() + time * 1000; //定义结束时间
					var lefttime = endtime - nowtime.getTime(), //距离结束时间的毫秒数
						leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)), //计算天数
						lefth = Math.floor((lefttime / (1000 * 60 * 60)) % 24), //计算小时数
						leftm = Math.floor((lefttime / (1000 * 60)) % 60), //计算分钟数
						lefts = Math.floor((lefttime / 1000) % 60); //计算秒数
					return leftd + '天' + lefth + '小时' + leftm + '分钟' + lefts + '秒'; //返回倒计时的字符串
				} else {
					return ' 00 天 00 小时 00 分钟 00 秒'; //返回倒计时的字符串
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.none-list {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		img {
			position: relative;
			left: calc(var(--proportion) * -60px);
			width: 230px;
			height: 170px;
		}
		div {
			position: relative;
			top: 20px;
			left: calc(var(--proportion) * -60px);
			font-size: 16px;

			font-weight: 400;
			color: rgba(255, 255, 255, 0.3);
		}
	}
	.el-input ::v-deep .el-input__inner {
		background-color: #1b1b1b;
		border: 1px solid #333333;
		color: #fff;
	}
	.content-box {
		position: relative;
		z-index: 9;
		.bj {
			overflow: hidden;
			img {
				width: 100%;
			}
		}
		.class-box {
			.class-box-nav {
				// margin-top: 47px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 94%;
				margin-left: 3%;
				// background: #1b1b1b;
				padding: 11px 25px;
				padding-left: 0;
				z-index: 9;
				.nav-left {
					display: flex;
					.title {
						font-size: 24px;

						// font-weight: bold;
						color: #ffffff;
						opacity: 0.85;
					}
					.item {
						// margin-left: 50px;
						// display: flex;
						// .nav {
						//   // font-size: 14px;
						//   font-size: 20px;

						//   // font-weight: 500;
						//   color: #ffffff85;
						//   // font-weight: bold;
						//   cursor: pointer;
						//   height: 32px;

						//   // opacity: 0.5;
						//   // background: #e60000;

						//   text-align: center;
						//   line-height: 32px;
						//   padding: 0 10px;
						//   margin-right: 20px;
						// }
						// .tap {
						//   background: #e60000;
						//   opacity: 1;
						//   color: #fff;
						// }
						// margin-top: calc(var(--proportion) * 14px);
						display: flex;
						justify-content: center;
						align-items: center;
						width: 100%;
						// margin-bottom: calc(var(--proportion) * 60px);

						::v-deep .el-tabs__nav-wrap::after {
							background-color: transparent !important;
						}

						::v-deep .el-tabs__item {
							position: relative;
							z-index: 4;
							padding: 0 24px;
							font-size: 20px;
							font-family: Alibaba PuHuiTi 2;
							font-weight: normal;
							color: rgba(255, 255, 255, 0.85) !important;
							&:nth-child(1) {
								padding-left: 0;
							}
						}

						::v-deep {
							.el-tabs__nav-wrap,
							.el-tabs__nav-scroll {
								overflow: visible;
							}
						}
						// 导航栏下划线
						::v-deep .el-tabs__active-bar {
							// bottom: -12px;
							// height: 4px;
							// background: #e60000;

							bottom: 2px;
							height: 4px;
							background: #e60000;
						}
					}
				}
				.nav-right {
				}
			}
			&-item {
				.material-share-list {
					margin-top: calc(var(--proportion) * 32px);
					box-sizing: border-box;
					padding-left: calc(var(--proportion) * 60px);
					width: 100%;
					min-height: 400px;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					flex-wrap: wrap;

					.material-share-item:nth-child(1) {
						margin-left: 0px;
						margin-right: calc(var(--proportion) * 12px);
					}

					.material-share-item:nth-child(4n + 1) {
						margin-left: 0px;
						margin-right: calc(var(--proportion) * 12px);
					}

					.material-share-item:nth-child(4n) {
						margin-right: 0px;
						margin-left: calc(var(--proportion) * 12px);
					}

					.material-share-item {
						cursor: pointer;
						margin: 0px calc(var(--proportion) * 12px);
						margin-bottom: calc(var(--proportion) * 24px);
						width: calc(var(--proportion) * 432px);
						min-height: calc(var(--proportion) * 340px);
						// cursor: pointer;
						background: #1b1b1b;
						&:hover .share-img {
							transform: scale(1.1);
						}

						.material-share-img {
							position: relative;
							// margin-bottom: calc(var(--proportion) * 32px);
							overflow: hidden;
							// width: calc(var(--proportion) * 417.36px);
							height: calc(var(--proportion) * 310px);

							.share-img.hover {
								// transform: scale(1.1);
							}

							.share-img {
								width: 100%;
								height: 100%;
								transition: all 1s;
							}

							.material-share-popup {
								position: absolute;
								top: 10px;
								right: 10px;
								//   background: rgba(0, 0, 0, 0.5);
								//   display: flex;
								//   justify-content: center;
								//   align-items: center;
								//   flex-direction: column;

								.title {
									margin-bottom: calc(var(--proportion) * 32px);
									// font-size: 1.09rem;
									font-size: 14px;

									// font-weight: bold;
									color: #ffffff;
									width: 52px;
									height: 24px;
									line-height: 24px;
									background: #000000;
									opacity: 0.5;
									border-radius: 2px;
									text-align: center;
								}

								.btn-download:hover {
									opacity: 0.9;
								}

								.btn-download {
									display: flex;

									justify-content: center;
									align-items: center;
									width: 114px;
									height: 48px;
									background: #e60000;
									font-size: 16px;

									// font-weight: 500;
									color: #ffffff;
									cursor: pointer;

									.btn-download-img {
										position: relative;
										top: 1.4px;
										margin-left: 7px;
										width: 11px;
										height: 12px;
									}
								}
							}
						}

						.material-share-title {
							display: flex;
							// margin-bottom: calc(var(--proportion) * 10px);
							margin: calc(var(--proportion) * 24px) calc(var(--proportion) * 24px)
								calc(var(--proportion) * 20px) calc(var(--proportion) * 24px);
							align-items: center;
							text-align: left;
							text-overflow: ellipsis;
							overflow: hidden;
							white-space: nowrap;
							font-size: 0.6rem;
							line-height: 0.6rem;
							// font-weight: bold;
							color: rgba(255, 255, 255, 0.85);
							// padding: 0 10px;

							span {
								margin-right: 9px;
								padding: 0px calc(var(--proportion) * 6px);
								height: calc(var(--proportion) * 24px);
								background: #e60000;
								border-radius: 2px;
								font-size: 0.42rem;
								font-weight: 500;
								color: #ffffff;
								line-height: calc(var(--proportion) * 24px);
							}
						}

						.material-share-label {
							display: flex;
							align-items: center;
							width: 120px;
							cursor: pointer;
							text-align: left;
							text-overflow: ellipsis;
							overflow: hidden;
							white-space: nowrap;
							font-size: 0.48rem;

							// font-weight: 400;
							color: rgba(255, 255, 255, 0.5);
							// padding: 0px 10px 20px;
							margin: 0 calc(var(--proportion) * 24px) calc(var(--proportion) * 24px)
								calc(var(--proportion) * 24px);
							.label_img {
								margin-left: 7px;
								margin-top: 3px;
								// width: calc(var(--proportion) * 12px);
								// height: calc(var(--proportion) * 12px);
								width: 12px;
								height: 12px;

								background: url('../image/jiantou1.png') no-repeat;
								// background-size: calc(var(--proportion) * 12px) calc(var(--proportion) * 12px);
								background-size: 12px 12px;
								background-position: center;
								opacity: 0.5;
							}
							&:hover {
								color: #e60000;
								.label_img {
									opacity: 1;
									background: url('../image/jiantou2.png') no-repeat;
								}
							}
						}
					}
				}
			}
		}
	}
	//

	.el-carousel {
		// width: 500px;
		.el-carousel__item:nth-child(2n) {
			background-color: #99a9bf;
		}
		.el-carousel__item:nth-child(2n + 1) {
			background-color: #d3dce6;
		}
		::v-deep .el-carousel__indicators {
			// 指示器
			// left: unset;
			// transform: unset;
			// right: 10%;
		}
		::v-deep .el-carousel__button {
			// 指示器按钮
			// width: 32px;
			// width: 20px;
			// height: 6px;
			// background: #ffffff;
			// // opacity: 0.3;
			// border: none;
		}
		::v-deep .is-active .el-carousel__button {
			// 指示器激活按钮
			// background: #e60000;
			// width: 32px !important;
		}
	}
	.banner_box {
		position: relative;
		.arrow_box {
			position: absolute;
			top: 60px;
			z-index: 998;
			// right: 400px;
			right: calc(var(--proportion) * 400px);
			width: 288px;
			height: 298px;
			background: #424042;
			// padding: calc(var(--proportion) * 20px);
			padding: 32px 24px;
			.mainTitle {
				font-size: 24px;

				// font-weight: bold;
				color: #ffffff;
				margin-bottom: 20px;
				margin-top: -4px;
				opacity: 0.85;
			}
			.subtitle {
				font-size: 16px;

				font-weight: 400;
				color: #ffffff;
				opacity: 0.5;
				margin-bottom: 88px;
				span {
					color: #e60000;
				}
			}
			.btn {
				position: absolute;
				// bottom: calc(var(--proportion) * 32px);
				// left: calc(var(--proportion) * 32px);
				bottom: 32px;
				left: 32px;
				cursor: pointer;
				font-size: 14px;

				font-weight: 400;
				color: #ffffff;
				opacity: 0.85;
				width: 124px;
				height: 48px;
				border: 1px solid #ffffff;
				opacity: 0.85;
				border-radius: 1px;
				text-align: center;
				line-height: 48px;
				&:hover {
					opacity: 0.95;
				}
			}
		}
	}

	.serve_box {
		// padding-top: 31px;
		background-color: #100f0f;
		position: relative;
		.serve_box-bj {
			position: absolute;
			z-index: 1;
			width: 100%;
			overflow: hidden;
		}
		.title {
			position: relative;
			text-align: center;
			// padding-top: 84px;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			.top {
				font-size: 48px;
				width: 100%;
				line-height: 1;

				// font-weight: bold;
				color: #ffffff;
				z-index: 6;
				// line-height: 36px;
				opacity: 0.85;
				margin-bottom: 24px;
			}
			.bottom {
				width: 100%;
				font-size: 28px;
				line-height: 1;

				// font-weight: 500;
				z-index: 6;
				color: #ffffff;
				// line-height: 36px;
				opacity: 0.5;
			}

			.serve_box_button {
				width: 155px;
				height: 48px;
				line-height: 48px;
				text-align: center;
				border: 1px solid #ffffff;
				opacity: 0.85;
				font-size: 14px;

				font-weight: 400;
				color: #ffffff;
				z-index: 999;
				margin-top: 15px;

				&:hover {
					background: #e60000;
					border: 0px solid #ffffff !important;
				}
			}
		}
	}

	.dividing-line {
		display: none;
		position: relative;
		top: -32px;
		z-index: 4;
		margin: 0px auto;
		width: 40px;
		height: 2px;
		background: #e60000;
	}

	// 轮播图指示器
	::v-deep {
		.el-carousel__button {
			width: calc(var(--proportion) * 40px);
			height: calc(var(--proportion) * 4px);
		}
		.is-active {
			.el-carousel__button {
				background: #e60000 !important;
			}
		}
	}

	// 大字标题
	.headline {
		padding-top: calc(var(--proportion) * 148px);
		margin-bottom: calc(var(--proportion) * 48px) !important;
		// font-size: calc(var(--proportion) * 52px) !important;
		font-size: 28px !important;
		font-weight: 600;
		letter-spacing: 4px;
	}
	// 小字标题
	.small_caption {
		opacity: 0.7 !important;
		margin-bottom: calc(var(--proportion) * 92px) !important;
		font-weight: 'PingFang SC', Helvetica, 'Microsoft YaHei';
		// font-size: calc(var(--proportion) * 16px) !important;
		font-size: 15px !important;
		font-weight: 100 !important;
		line-height: 1 !important;
	}
	.mar-bottom {
		margin-bottom: calc(var(--proportion) * 48px) !important;
	}
</style>
